'use client';

import './AppBar.css';

import { Link } from '@/i18n/navigation';
import { useTranslations, useLocale } from 'next-intl';
import { useRouter, usePathname } from '@/i18n/navigation';
import Image from 'next/image';

import { useState } from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';

export default function AppBar() {
    const [expanded, setExpanded] = useState(false);
    const locale = useLocale();
    const router = useRouter();
    const pathname = usePathname();

    const handleNavItemClick = () => {
        setExpanded(false);
    };

    const handleLanguageChange = (newLocale: string) => {
        router.replace(pathname, { locale: newLocale });
        setExpanded(false);
    };

    const t = useTranslations('linkNames');
    
    return (
        <Navbar expand="lg" sticky="top" className="custom-navbar" expanded={expanded} onToggle={setExpanded}>
            <Container>
                <Navbar.Brand as={Link} href="/" style={{ cursor: 'pointer' }}>
                    <Image
                        src="/assets/tukiluotsi_logo_text.png"
                        alt="Tukiluotsi logo"
                        width={180}
                        height={33}
                        sizes="180px"
                        style={{ objectFit: 'contain' }}
                        priority
                    />
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="main-navbar" className="custom-navbar-toggle" />
                <Navbar.Collapse id="main-navbar">
                    <Nav className="ms-auto">
                        <Nav.Item as="span">
                            <Link
                                href="/tarinamme"
                                className="nav-link"
                                onClick={handleNavItemClick}
                            >
                                {t("about").toUpperCase()}
                            </Link>
                        </Nav.Item>

                        <NavDropdown title={t('services').toUpperCase()}>
                            <NavDropdown.Item as="span">
                                <Link
                                    href="/palvelut"
                                    className="dropdown-item"
                                    onClick={handleNavItemClick}>
                                    {t('allServices')}
                                </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="span">
                                <Link
                                    href="/palvelut/ammatillinen-tukihenkilotyo"
                                    className="dropdown-item"
                                    onClick={handleNavItemClick}
                                >
                                    {t('professionalSupportServices')}
                                </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="span">
                                <Link
                                    href="/palvelut/tehostettu-perhetyo"
                                    className="dropdown-item"
                                    onClick={handleNavItemClick}
                                >
                                    {t('enhancedFamilySupport')}
                                </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="span">
                                <Link
                                    href="/palvelut/perhetyo"
                                    className="dropdown-item"
                                    onClick={handleNavItemClick}
                                >
                                    {t('familyWork')}
                                </Link>
                            </NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Item as="span">
                            <Link
                                href="/rekrytointi"
                                className="nav-link"
                                onClick={handleNavItemClick}
                            >
                                {t("recruitment").toUpperCase()}
                            </Link>
                        </Nav.Item>
                        <Nav.Item as="span">
                            <Link
                                href="/yhteystiedot"
                                className="nav-link"
                                onClick={handleNavItemClick}
                            >
                                {t("contact").toUpperCase()}
                            </Link>
                        </Nav.Item>
                        <NavDropdown title={locale.toUpperCase()}>
                            <NavDropdown.Item onClick={() => handleLanguageChange(locale === 'fi' ? 'en' : 'fi')}>
                                {locale === 'fi' ? 'EN' : 'FI'}
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}